import { UseFormGetValues, UseFormSetValue } from "react-hook-form";
import { TFunction } from "i18next";

import { convertAnyToPdfBlobFrontendOnly, makePdfFileName } from "src/utils/docUploads/convert-files-to-pdf";
import { ChallengeDocument, ChallengeFormValues } from "src/types/challenge-form-types";

type ConvertFn = (file: File, t: TFunction) => Promise<Blob>;

export async function convertDocumentsToPdf(
  getValues: UseFormGetValues<ChallengeFormValues>,
  setValue: UseFormSetValue<ChallengeFormValues>,
  t: TFunction,
  convert: ConvertFn = convertAnyToPdfBlobFrontendOnly
): Promise<boolean> {
  const documents = getValues("documents") ?? [];

  if (documents.length === 0) {
    return true;
  }

  let nextDocuments: ChallengeDocument[] = [...documents];
  let hasError = false;
  const currentConvertedFileNames: string[] = [];

  for (const doc of documents) {
    if (doc.convertedPdf) {
      currentConvertedFileNames.push(doc.convertedPdf.fileName.replace(".pdf", ""));
      continue;
    }

    try {
      const pdfBlob = await convert(doc.file, t);
      const pdfName = makePdfFileName(doc.file.name, currentConvertedFileNames);
      currentConvertedFileNames.push(pdfName.replace(".pdf", ""));

      nextDocuments = nextDocuments.map((d) =>
        d.id === doc.id
          ? {
              ...d,
              convertedPdf: {
                fileName: pdfName,
                blob: pdfBlob,
              },
            }
          : d
      );
    } catch {
      hasError = true;

      nextDocuments = nextDocuments.map((d) =>
        d.id === doc.id
          ? {
              ...d,
              convertedPdf: undefined,
            }
          : d
      );
    }
  }

  setValue("documents", nextDocuments, {
    shouldDirty: true,
    shouldValidate: true,
  });

  return !hasError;
}
